import * as mac from "@/data/api/mac"
import {getTestData} from "@/data/repos/mockDataLoader"

export async function getStoredProcedure(
  database: string, storedProcedure: string, args: any[] = [],
  filter?: (x: any) => any,
  offset?: number, limit?: number): Promise<any[]> {
  if (process.env.NODE_ENV === "test") {
    return getTestData(storedProcedure)
  }
  try {
    const r = await mac.api.post("sp?name=" + encodeURIComponent(storedProcedure), {
      storedProcedure,
      database,
      args,
      offset,
      limit,
    })
    if (r && "data" in r) {
      try {
        return filter ? filter(r.data) : r.data
      } catch (err) {
        console.error("Data filter failed in getStoredProcedure:", err)
        return []
      }
    } else {
      console.error("getStoredProcedure failed",
        "database:", database, "storedProcedure:", storedProcedure, "args:", args, "error:", r)
      return []
    }
  } catch (err) {
    console.error("getStoredProcedure failed",
      "database:", database, "storedProcedure:", storedProcedure, "args:", args, "error:", err)
    return []
  }
}
